import MutateUser from "./MutateUser";

export default MutateUser